import React from 'react';
import { FormattedLink, WysiwygField } from '../../../components';
import Video from '../../../components/Video';

const ParagraphVideo = ({ entity }) => {
  const video = entity.getIn(['field_video', 0]);
  const mimetype = video.get('mimetype', 0);
  const source = video.get('source', 0);
  const poster = video.get('poster', '');
  const link = entity.get('field_link');

  return (
    <div className="Paragraph ParagraphVideo">
      <h2>{entity.getIn(['field_title', 0, 'value'])}</h2>
      <WysiwygField
        className="u-margin--bottom--5"
        property="schema:text"
        html={entity.getIn(['field_text', 0, 'processed'])}
      />

      <Video
        controls
        playsInline
        poster={poster.replace(/\.(png|gif|jp(e?)g)/ig, '.webp')}
        sources={[
          {
            src: source,
            type: mimetype,
          },
        ]} />
      <div className="ParagraphBlockReference__link u-margin--top--7">
        <FormattedLink link={link} />
      </div>
    </div>
  );
};

export default ParagraphVideo;
